import Api from '@nextories/vue-core-components/src/utils/Api';
import type { ProjectRequest } from '@/types/ProjectRequest';

type StrInt = string | number;

export default class AppApi extends Api {
  public partner: StrInt | undefined;

  setPartner(id: StrInt) {
    this.partner = id;
  }

  /**
   * Retrieve the project of the current user from the backend
   * @returns {Promise<Object>} resolve with the project for the current user
   * or reject with the backend error message
   */
  getPartner(partnerId?: StrInt, configId?: StrInt) {
    let query = `config_id=${configId}`;
    if (partnerId) {
      this.setPartner(partnerId);
      query = `partner=${partnerId}&config_id=${configId}`;
    }
    // eslint-disable-next-line no-underscore-dangle
    return this._methodData('get', `booking/config-partner?${query}`);
  }

  getOnlineBooking() {
    // eslint-disable-next-line no-underscore-dangle
    return this._methodData('get', `booking/online/${this.crmToken || this.projectToken}`);
  }

  getTypeMeetingAvailable() {
    // eslint-disable-next-line no-underscore-dangle
    return this._methodData('get', `booking/mettype-available/${this.projectToken}`);
  }

  postAllowEstimate(request: {}) {
    // eslint-disable-next-line no-underscore-dangle
    return this._methodData('post', 'booking/check-allow-estimate/', request);
  }

  getEstimate() {
    // eslint-disable-next-line no-underscore-dangle
    return this._methodData('get', `booking/estimation/${this.projectToken}`);
  }

  postProject(request: ProjectRequest) {
    // eslint-disable-next-line no-underscore-dangle
    return this._methodData('post', 'booking/api-partner/', request);
  }

  postCalcMinarmRights(request: {
    partner: StrInt | undefined
  }) {
    request.partner = this.partner;
    // eslint-disable-next-line no-underscore-dangle
    return this._methodData('post', 'booking/calcul-plafond-minarm/', request);
  }

  updateProject(request: ProjectRequest) {
    request.token = this.projectToken;
    request.crm_token = this.crmToken;
    // eslint-disable-next-line no-underscore-dangle
    return this._methodData('post', 'booking/api-partner/', request);
  }
}
